import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/liq`;

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('liq_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('liq_token');
      localStorage.removeItem('liq_user');
      if (window.location.pathname.startsWith('/liq') && !window.location.pathname.endsWith('/login')) {
        window.location.href = '/liq/login';
      }
    }
    return Promise.reject(err);
  }
);

// ---- Vocabularies (mirror of backend enums) ----
export const CLIENT_TYPES = [
  ['INDIVIDUAL', 'Individual'],
  ['FOUNDER_GROUP', 'Founder Group'],
  ['INVESTOR', 'Investor'],
  ['COMPANY', 'Company'],
  ['LLC', 'LLC'],
  ['C_CORPORATION', 'C Corporation'],
  ['S_CORPORATION', 'S Corporation'],
  ['PRIVATE_LIMITED_COMPANY', 'Private Limited Company'],
  ['LLP', 'LLP'],
  ['PARTNERSHIP', 'Partnership'],
  ['TRUST', 'Trust'],
  ['OTHER', 'Other'],
];
export const CLIENT_STATUSES = ['Prospect', 'Active', 'Dormant', 'Terminated'];

export const ENTITY_TYPES = [
  ['LLC', 'LLC'],
  ['C_CORPORATION', 'C Corporation'],
  ['S_CORPORATION', 'S Corporation'],
  ['PRIVATE_LIMITED_COMPANY', 'Private Limited Company'],
  ['LLP', 'LLP'],
  ['PARTNERSHIP', 'Partnership'],
  ['TRUST', 'Trust'],
  ['OTHER', 'Other'],
];
export const ENTITY_STATUSES = ['Incorporating', 'Active', 'Dissolved', 'Suspended'];

export const EMPLOYEE_ROLES = [
  'Legal IQ Lead', 'Legal Operations Lead', 'Legal Intelligence Lead', 'QA Lead',
  'Ops Control Lead', 'Client Delivery Owner', 'Client Relationship Mgr',
  'Commercial Lead', 'Finance & Billing Lead', 'Marketing & Content Lead', 'Filings Lead',
];
export const EMPLOYEE_STATUSES = ['Active', 'Inactive', 'On Leave'];
export const GENDERS = ['male', 'female', 'unspecified'];
export const CAPABILITY_LEVELS = ['L1 - Learning', 'L2 - Assisted', 'L3 - Independent', 'L4 - Reviewer', 'L5 - Lead'];
export const TRAINING_STATUSES = ['Not Started', 'In Progress', 'Under Review', 'Passed', 'Failed'];
export const APPROVAL_STATUSES = ['Pending Assessment', 'Approved', 'Restricted', 'Suspended'];
export const ENTITY_KINDS = ['human', 'agent'];
export const GROUP_CHAT_PARTICIPATION = ['always', 'when-relevant', 'silent-observer', 'never'];
export const COMMUNICATION_LANGUAGES = ['English', 'Hindi', 'Hinglish'];

export const CONTACT_ROLES = ['Founder', 'CFO', 'CEO', 'Legal', 'Operations', 'Finance', 'Investor', 'Other'];
export const CONTACT_TYPES = ['Primary', 'Backup', 'Billing', 'Legal', 'Technical', 'General'];
export const CONTACT_STATUSES = ['Active', 'Inactive', 'Left Company'];
export const COMM_PREFS = ['Email', 'Phone', 'WhatsApp', 'Meeting', 'Slack'];

export const MATTER_STAGES = [
  'Intake', 'Scoping', 'Drafting', 'Legal Review', 'QA Review',
  'Client Review', 'Execution', 'Filing', 'Closed', 'On Hold',
];
export const MATTER_COMM_STATUSES = [
  'Awaiting Client', 'Awaiting Internal', 'In Discussion', 'Blocked', 'Up to Date',
];
export const ASSIGNMENT_ROLES = ['Owner', 'Drafter', 'Legal Reviewer', 'QA Reviewer', 'Filer', 'Observer'];

export const TASK_STATUSES = ['Open', 'In Progress', 'Blocked', 'Done', 'Cancelled'];
export const TASK_PRIORITIES = ['P0', 'P1', 'P2', 'P3'];

export const DOC_TYPES = ['Draft', 'Executed', 'Filing', 'Certificate', 'KYC', 'Correspondence', 'Other'];
export const DOC_PROVIDERS = ['google-drive', 's3', 'ops-hub-drive'];
export const DOC_VISIBILITIES = ['internal', 'client-shared'];
export const DOC_STATUSES = ['Received', 'Under Review', 'Approved', 'Executed', 'Superseded', 'Archived'];

export const APPROVAL_REVIEWER_ROLES = ['Legal', 'QA', 'Client', 'Ops', 'Filer'];
export const APPROVAL_DECISIONS = [
  'Proposed', 'Under Review', 'Returned for Correction',
  'Approved', 'Client Approved', 'Executed', 'Completed',
];

export const clientTypeLabel = (code) => (CLIENT_TYPES.find(([c]) => c === code) || [code, code])[1];
export const entityTypeLabel = (code) => (ENTITY_TYPES.find(([c]) => c === code) || [code, code])[1];
